/* eslint-disable react/require-default-props */
import React, { memo } from 'react';
import { translate } from '@utils/i18n';
import { Text } from '@ui';
import TooltipText from '@components/v2/TooltipText';
import dateFormatter from '../../../ActivityFeed/utils/dateFormatter';
function TimeDisplay({ timestamp }) {
    const date = new Date(timestamp);
    const fullDateTime = date.toLocaleString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    });
    return (React.createElement("div", { className: "time-display", "aria-label": `${translate('time_display.time_label', {
            namespace: 'features.iim_review.submissions_timeline'
        })}: ${fullDateTime}` },
        React.createElement(TooltipText, { text: fullDateTime, position: "top" },
            React.createElement(Text, { variant: "x-small", as: "span", className: "time-label" }, dateFormatter(date)))));
}
export default memo(TimeDisplay);
